export enum FeedTypes {
  MARKET_FEED = 'MARKET_FEED',
  MARKET_FEED_ADJUSTED = 'MARKET_FEED_ADJUSTED',
  ALPHA_PRICES = 'ALPHA_PRICES',
  MANUAL_ENTRY = 'MANUAL_ENTRY',
}
